// Live agent status — the animated sparkle + a shimmering label, sitting in
// the gap just above the composer. Absent when idle; gently "breathes" while
// the agent works. Replaces the old status pill.

import type { StatusPayload } from '../../protocol/types';
import { SparklesIcon } from '../ui/Icons';

function describe(status: StatusPayload): string | null {
  switch (status.state) {
    case 'idle':
      return null;
    case 'thinking':
      return 'Thinking…';
    case 'responding':
      return 'Responding…';
    case 'waitingForTool':
      return 'Using Tools…';
    case 'compacting':
      return 'Compacting…';
    default:
      return `${status.state}…`;
  }
}

export function StatusStrip({ status }: { status: StatusPayload | null }) {
  if (!status) return null;
  const verb = describe(status);
  if (!verb) return null;

  return (
    <div className="mb-2 flex items-center gap-2.5 pl-1.5">
      <span className="flex h-5 w-5 items-center justify-center text-thinking-accent animate-breathe">
        <SparklesIcon size={18} animate />
      </span>
      <span className="status-shimmer text-[15px] font-semibold">{verb}</span>
    </div>
  );
}
